/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/RichTextBox/theme';

export const RichTextBoxTheme = theme;
